import { render, staticRenderFns } from "./VesselTrackManagement.vue?vue&type=template&id=c4fcf932&scoped=true&"
import script from "./VesselTrackManagement.vue?vue&type=script&lang=js&"
export * from "./VesselTrackManagement.vue?vue&type=script&lang=js&"
import style0 from "./VesselTrackManagement.vue?vue&type=style&index=0&id=c4fcf932&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4fcf932",
  null
  
)

export default component.exports